import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalInvestmentPlan {
  id: number;
  name: string;
  current_age: number;
  withdrawal_start_age: number;
  life_expectancy: number;
  initial_net_worth: number;
  monthly_contribution: number;
  withdrawal_amount?: number;
  expected_nominal_annual_return: number;
  expected_annual_inflation: number;
  created_at: string;
  updated_at?: string;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listInvestmentPlans() {
  return dbGetAll<LocalInvestmentPlan>('investment_plans');
}

export function getInvestmentPlanById(id: number) {
  return dbGetById<LocalInvestmentPlan>('investment_plans', id);
}

export async function getInvestmentPlanByServerId(serverId: number) {
  const all = await listInvestmentPlans();
  return all.find((plan) => plan.server_id === serverId);
}

export async function createInvestmentPlan(
  data: Omit<LocalInvestmentPlan, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>
) {
  const now = new Date().toISOString();
  return dbAdd('investment_plans', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateInvestmentPlan(id: number, data: Partial<LocalInvestmentPlan>) {
  const current = await dbGetById<LocalInvestmentPlan>('investment_plans', id);
  if (!current) throw new Error('Investment plan not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true,
  };
  await dbPut('investment_plans', updated);
  return updated;
}

export function removeInvestmentPlan(id: number) {
  return dbDelete('investment_plans', id);
}

export async function markInvestmentPlanSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalInvestmentPlan>('investment_plans', id);
  if (!current) throw new Error('Investment plan not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('investment_plans', current);
  return current;
}
